<template>
  <div class="top-menu">
    <v-toolbar app :fixed="!absolute" :flat="absolute" class="tab-container" :class="{__absolute: absolute}" :height="height">
        <!-- ancestoral element to all top headers -->
        <slot name="topHeader"></slot>
    </v-toolbar>
</div>
</template>

<script>
export default {
  props: {
    absolute: Boolean,
    height: {
      default: '71',
    },
  },
}
</script>

<style src="../../static/styles/topHeader.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// contentTopHeader.vue?4da0973e